/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Already_AcceptedInputs */

const es_co2_error_invitation_already_accepted = /** @type {(inputs: Error_Invitation_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta invitación ya fue aceptada.`)
};

/**

* @param {Error_Invitation_Already_AcceptedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_invitation_already_accepted = /** @type {((inputs?: Error_Invitation_Already_AcceptedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Already_AcceptedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_invitation_already_accepted(inputs)
});